import { TrainingStatusCode } from "../../../../api/training/Training.typed";
import { FOLLOWUP_EDIT_KEYS, FOLLOWUP_VIEW_KEYS } from "../../../../api/zekay/permissions";
import { usePermissions } from "../../../../contexts/app/permissions";
import { resolveTrainingStatusCode } from "../../../trainings/common/trainingStatusDisplay";

export type FollowUpAccess = {
  canView: boolean;
  canEdit: boolean;
};

export function isFollowUpEditableStatus(status: string | number | undefined): boolean {
  const code = resolveTrainingStatusCode(status);

  return code === TrainingStatusCode.InProgress || code === TrainingStatusCode.Done;
}

export function useFollowUpAccess(status: string | number | undefined): FollowUpAccess {
  const { hasAnyPermission } = usePermissions();
  const canView = hasAnyPermission(FOLLOWUP_VIEW_KEYS);
  // Mirrors API `ensureFollowUpEditable` (409 outside in progress / completed).
  const canEdit = hasAnyPermission(FOLLOWUP_EDIT_KEYS) && isFollowUpEditableStatus(status);

  return { canView, canEdit };
}
